import React from 'react';
import { Anchor } from '../Link';

interface DocumentDownloadLinkProps {
  downloadUrl: string;
  children: React.ReactNode;
}

export function DocumentDownloadLink({
  downloadUrl,
  children,
}: DocumentDownloadLinkProps) {
  return (
    <Anchor
      href={downloadUrl}
      color="grey"
      target="_blank"
      rel="noopener noreferrer"
      // Let a drag started on the name fall through to the draggable row so the
      // row's drag image shows, instead of the browser's native link ghost.
      draggable={false}
    >
      {children}
    </Anchor>
  );
}
